import { pxToRem } from './utils/pxToRem';

export const Forms = {
  label: {
    sm: {
      fontSize: pxToRem(14),
      lineHeight: 1.5,
      letterSpacing: pxToRem(0.15),
      marginBottom: pxToRem(12),
    },
    lg: {
      fontSize: pxToRem(16),
      lineHeight: 1.75,
      letterSpacing: pxToRem(0.05),
      marginBottom: pxToRem(12),
    },
  },
  input: {
    sm: {
      fontSize: pxToRem(13),
      letterSpacing: pxToRem(0.1),
      lineHeight: 1.85,
      padding: `${pxToRem(6)} ${pxToRem(15)}}`,
      height: pxToRem(36),
    },
    md: {
      fontSize: pxToRem(14),
      letterSpacing: pxToRem(0.09),
      lineHeight: 1.71,
      padding: `${pxToRem(8)} ${pxToRem(15)}}`,
      height: pxToRem(40),
    },
    lg: {
      fontSize: pxToRem(15),
      letterSpacing: pxToRem(0.1),
      lineHeight: 1.6,
      padding: `${pxToRem(11)} ${pxToRem(15)}}`,
      height: pxToRem(46),
    },
  },
  textarea: {
    sm: {
      fontSize: pxToRem(13),
      letterSpacing: pxToRem(0.1),
      lineHeight: 1.85,
      padding: `${pxToRem(6)} ${pxToRem(15)}}`,
      height: pxToRem(36),
    },
    md: {
      fontSize: pxToRem(14),
      letterSpacing: pxToRem(0.09),
      lineHeight: 1.71,
      padding: `${pxToRem(8)} ${pxToRem(15)}}`,
      height: pxToRem(40),
    },
    lg: {
      fontSize: pxToRem(15),
      letterSpacing: pxToRem(0.1),
      lineHeight: 1.6,
      padding: `${pxToRem(11)} ${pxToRem(15)}}`,
      height: pxToRem(46),
    },
  },
  checkbox: {
    sm: {
      height: pxToRem(18),
      width: pxToRem(18),
      gap: pxToRem(19),
      gapInline: pxToRem(23),
    },
    lg: {
      height: pxToRem(24),
      width: pxToRem(24),
      gap: pxToRem(20),
      gapInline: pxToRem(30),
    },
  },
  radio: {
    sm: {
      height: pxToRem(18),
      width: pxToRem(18),
      innerWidth: pxToRem(9),
      innerHeight: pxToRem(9),
      gap: pxToRem(19),
      gapInline: pxToRem(23),
    },
    lg: {
      height: pxToRem(24),
      width: pxToRem(24),
      innerWidth: pxToRem(12),
      innerHeight: pxToRem(12),
      gap: pxToRem(20),
      gapInline: pxToRem(30),
    },
  },
};
